import { Accordion } from '@noissue-ui-kit/accordion'
import dynamic from 'next/dynamic'
import { Spacer } from '../ConfigurableSpacer/Spacer'
import { IConfigurableAccordion } from 'utils/contentful/contentfulComponents/parsers/parseConfigurableAccordion'
import * as Sentry from '@sentry/nextjs'

const DynamicConfigurableList = dynamic(
  () =>
    import('app/_components/ContentfulPage/ConfigurableList/ConfigurableList')
)
const DynamicStandaloneHorizontalFeature = dynamic(
  () =>
    import(
      'app/_components/ContentfulPage/ConfigurableFeatures/StandaloneHorizontalFeature/StandaloneHorizontalFeature'
    )
)
const DynamicConfigurableDescriptionList = dynamic(
  () => import('../ConfigurableDescriptionList/ConfigurableDescriptionList')
)
const DynamicConfigurableCard = dynamic(() => import('../ConfigurableCard'))
const DynamicConfigurableSlider = dynamic(() => import('../ConfigurableSlider'))
const DynamicConfigurableTileList = dynamic(
  () => import('../ConfigurableTileList')
)
const DynamicConfigurableTile = dynamic(() => import('../ConfigurableTile'))

const componentMapper = {
  featuresList: DynamicConfigurableList,
  feature: DynamicStandaloneHorizontalFeature,
  spacer: Spacer,
  configurableDescriptionList: DynamicConfigurableDescriptionList,
  configurableCard: DynamicConfigurableCard,
  configurableSlider: DynamicConfigurableSlider,
  configurableTileList: DynamicConfigurableTileList,
  configurableTile: DynamicConfigurableTile,
}

const componentSpecificProps = {
  configurableDescriptionList: {
    omitTitles: true,
  },
}

const renderComponent = (component: any) => {
  if (!component || !component.componentKey) {
    Sentry.captureMessage('Component is missing or has no componentKey', {
      extra: { component },
    })
    return null
  }

  const MappedComponent = componentMapper[component.componentKey]

  if (!MappedComponent) {
    Sentry.captureMessage(`Unknown component type: ${component.componentKey}`)
    return null
  }

  return (
    <MappedComponent
      key={component.id || component.componentKey}
      {...component}
      {...componentSpecificProps[component.componentKey]}
    />
  )
}

export function ConfigurableAccordion({
  sections,
  className,
}: IConfigurableAccordion & { className?: string }) {
  if (!sections?.length) {
    Sentry.captureMessage(
      'Render Error. Accordion is missing sections or sections array is empty.'
    )
    return null
  }

  return (
    <div className={className}>
      <Accordion
        sections={sections
          .map((section) => {
            return {
              id: section.id,
              title: section.title,
              children:
                section.components?.map(renderComponent).filter(Boolean) || [],
            }
          })
          .filter(Boolean)}
      />
    </div>
  )
}
